module.exports = __webpack_public_path__ + "img/Performing-Arts-t-22049-003.135a01ac.jpg";